import { Palette } from 'config';
import styled from 'styled-components';

export const AppContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 16px 20px;
  background: ${Palette.PrimaryGray._000};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  border: ${({ showBorder }) => showBorder && `1px solid ${Palette.Red._300}`};
`;

export const ChangeAppButton = styled.button`
  display: flex;
  flex: 0 0 437px;
  margin: 0 !important;
`;

export const OrSeperator = styled.div`
  display: flex;
  flex: 0 0 16px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  color: ${Palette.PrimaryGray._400};
`;

export const SelectedApp = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const ButtonsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: space-between;
`;
export const AppInfo = styled.div`
  width: 100%;
  gap: 16px;
  background: var(--app-white);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
`;
export const AppName = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
`;
export const ImgInfo = styled.div`
  width: 40px;
  height: 40px;
  display: block !important;
  flex-shrink: 0;

  img {
    display: block !important;
    width: 100%;
    height: 100%;
  }
`;
export const AppNameText = styled.span`
  font-weight: 400;
  font-size: 12px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._900};
`;
export const PackageName = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._500};
`;

export const Content = styled.div`
  min-height: 88px;
`;

export const ErrorWrap = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Palette.Red._500};
    margin-left: 8px;
  }
`;
